import useAuthenticatedUsers from 'hooks/user/useAuthenticatedUsers';
import isEmpty from 'lodash/isEmpty';

export const checkRoles = ({ roles, user }) => {
  if (!roles || roles.length < 1) {
    return true;
  }

  return roles.includes(user.role.id);
};

// check an authenticatedUser's feature set
export const checkFeatures = ({ features, user }) => {
  if (features.length < 1) {
    return true;
  }

  return features.every((x) => !!user.features?.[x]);
};

export const checkAccessGroups = ({ accessGroups, user }) => {
  if (!accessGroups?.length) {
    return true;
  }
  return accessGroups.every(
    (requiredAccessGroup) => user.groups.some(
      (accessGroup) => accessGroup === requiredAccessGroup,
    ),
  );
};

const PermissionsCheck = ({
  roles = [], features = [], accessGroups, children,
}) => {
  const { selectedAuthenticatedUser: user } = useAuthenticatedUsers();
  if (
    user
    && checkRoles({ roles, user })
    && checkFeatures({ features, user })
    && checkAccessGroups({ accessGroups, user })
  ) {
    return children;
  }

  return null;
};

const Permissions = ({
  roles = [], features = [], accessGroups, children,
}) => {
  if (isEmpty(roles) && isEmpty(features)) {
    return children;
  }

  return PermissionsCheck({
    roles, features, accessGroups, children,
  });
};

export default Permissions;
